export default __webpack_public_path__ + "static/media/chip.fa1faa0f.svg";